// @flow
import React from 'react'

type Props = {
  id: string,
  name: string,
  defaultValue?: string,
  errors: Array<Object>,
  type?: string,
  disabled?: boolean,
}

export default class FormInput extends React.Component<Props> {
  render () {
    let errorClass = ''
    if (this.props.errors) {
      errorClass = 'input-error-message'
    }

    // The 'is' props below is needed to make the 'disabled' props work as expected,
    // i.e. set disabled='disabled', https://stackoverflow.com/a/33860892
    return (
      <input
        is
        class={`form__input ${errorClass}`}
        type={this.props.type || 'text'}
        id={this.props.id}
        name={this.props.name}
        defaultValue={this.props.defaultValue || ''}
        disabled={this.props.disabled ? 'disabled' : undefined}
      />
    )
  }
}

window.Components.FormInput = React.createFactory(FormInput)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/FormInput.js